import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: any) => ({
  side_panel_header_container: {
    display: "flex",
    borderBottom: `1px solid ${theme.palette.divider}`,
    justifyContent: "space-between",
  },
  title: {
        fontSize: '12px',
        color: theme.palette.grey["600"],
        fontWeight: 800
  },
  deliveryStepItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px 16px",
    marginBottom: "8px",
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: "4px",
    transition: "all 0.2s ease",
    "&:hover": {
      boxShadow: theme.shadows[2],
      backgroundColor: theme.palette.action.hover,
    },
    "&.dragging": {
      opacity: 0.5,
      backgroundColor: theme.palette.action.selected,
    },
  },
  deliveryStepContent: {
    display: "flex",
    alignItems: "center",
    flex: 1,
    gap: "12px",
  },
  deliveryStepInfo: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  deliveryStepName: {
    fontSize: "14px",
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  deliveryStepId: {
    fontSize: "12px",
    color: theme.palette.text.secondary,
  },
  deliveryStepStatus: {
    fontSize: "12px",
    fontWeight: 500,
    padding: "4px 8px",
    borderRadius: "4px",
    backgroundColor: theme.palette.action.hover,
  },
  statusPending: {
    backgroundColor: theme.palette.warning.light,
    color: theme.palette.warning.dark,
  },
  statusInProgress: {
    backgroundColor: theme.palette.info.light,
    color: theme.palette.info.dark,
  },
  statusDelivered: {
    backgroundColor: theme.palette.success.light,
    color: theme.palette.success.dark,
  },
  dragHandle: {
    cursor: "grab",
    display: "flex",
    alignItems: "center",
    color: theme.palette.text.secondary,
    marginRight: "8px",
    "&:active": {
      cursor: "grabbing",
    },
  },
  actionButtons: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
  },
  deleteButton: {
    color: theme.palette.error.main,
    "&:hover": {
      backgroundColor: theme.palette.error.light,
    },
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "32px 16px",
    color: theme.palette.text.secondary,
    textAlign: "center",
  },
  emptyStateIcon: {
    fontSize: "48px",
    marginBottom: "16px",
    opacity: 0.5,
  },
  sidePanelContent: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    padding: "16px",
  },
  deliveryStepsList: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    maxHeight: "calc(100vh - 200px)",
    overflowY: "auto",
  },
  orderNumber: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "32px",
    height: "32px",
    borderRadius: "50%",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontWeight: 600,
    fontSize: "12px",
  },
  sidePanelHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingBottom: "12px",
  },
  sidePanelTitle: {
    fontSize: "16px",
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  saveButton: {
    marginTop: "16px",
    width: "100%",
  },
  main_button: {
    backgroundColor: theme.palette.common.white,
    "&:hover": {
      backgroundColor: theme.palette.primary.light,
    },
  }
}));

export { useStyles };
